import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { isString } from 'util';

export function toMoment(ngbDate: NgbDateStruct): moment.Moment {
	return moment.utc({
		year: ngbDate.year,
		month: ngbDate.month - 1,
		day: ngbDate.day
	});
}

export function flatten<T>(array: T[][]): T[] {
	return ([] as T[]).concat(...array);
}

export function toNgbDateStruct(date: string | moment.Moment | NgbDateStruct, format: string = "DD/MM/YYYY") {
	let momentDate: moment.Moment;
	if (moment.isMoment(date)) {
		momentDate = date as moment.Moment;
	} else if (isString(date)) {
		momentDate = moment(date, format);
	} else {
		return date as NgbDateStruct;
	}

	return {
		year: momentDate.get('year'),
		month: momentDate.get('month') + 1,
		day: momentDate.get('date')
	};
}

export async function delayAsync(timeout: number = 0) {
	return new Promise((resolve, reject) => {
		setTimeout(resolve, timeout);
	});
}

export function generateAuthForScT(codiceFiscale, prepared = true) {
	const userData = JSON.parse(localStorage.getItem('agenda-web'))
	const accessToken = userData['access']
	const refreshToken = userData['refresh']

	const data = {
		"auth-cookie-shortcut": JSON.stringify({
			token: accessToken,
			codice_fiscale: codiceFiscale,
			codice_fiscale_medico: codiceFiscale,
			refresh_expires: refreshToken
		})
	}

	if (prepared) {
		return btoa(JSON.stringify(data))
	} else {
		return data
	}

}

export function stackTrace() {
	const err = new Error()
	return err.stack
}

export function getDataForOauth() {
	return localStorage.getItem('auth-cookie-shortcut')
}

export function prepareDataForAuth(caller: string = '') {
	const userData = JSON.parse(getDataForOauth())

	const data = {
		"auth-cookie-shortcut": JSON.stringify(userData)
	}

	const buffer = btoa(JSON.stringify(data))

	console.log(`${caller} prepareDataForAuth: data`, data)
	console.log(`${caller} prepareDataForAuth: buffer`, buffer)

	return buffer
}


// WEBPACK FOOTER //
// ./src/utils.ts